import { Suspense, type ReactNode } from "react";

import { SplashScreen } from "./SplashScreen";

/**
 * How long a route chunk may take before we admit to loading.
 *
 * Built chunks are small and same-origin — SignInPage is 2.6 kB — so in
 * production this fires only on a genuinely slow connection, which is the case
 * the fallback exists for. The dev server is a different animal: it serves
 * every import as its own module request, so a first visit to a route issues
 * dozens of them and reliably crosses any sane threshold. That is a property
 * of the dev server, not of the app, and flashing a splash over it just trains
 * you to ignore a real signal.
 */
const FALLBACK_DELAY_MS = import.meta.env.DEV ? 1500 : 250;

/** Suspense boundary for lazily-loaded route modules. */
export function LazyRoute({ children }: { children: ReactNode }) {
  return (
    <Suspense fallback={<SplashScreen delayMs={FALLBACK_DELAY_MS} />}>
      {children}
    </Suspense>
  );
}
